import { Reducer } from 'redux';
import {
  IHelpCenter,
  Types,
  FAQProps,
  HelpCenterCategory,
  HelpCenterTopic
} from './types';

const INITIAL_STATE: IHelpCenter = {
  faq: {
    categories: [],
    question: [],
    query: {
      searchTerm: '',
      results: []
    },
    suggestions: []
  },
  commerce: {
    categories: [],
    topicsByCategory: {},
    searchResults: [],
    loadingCategories: false,
    loadingTopics: false,
    error: false
  },
  initialized: false,
  loading: false,
  error: false
};

type TCustomAction = {
  type: Types;
  payload: {
    faq: FAQProps;
    categories: HelpCenterCategory[];
    categoryId: number;
    topics: HelpCenterTopic[];
    results: HelpCenterTopic[];
  };
};

const reducer: Reducer<IHelpCenter, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_HELPCENTER:
      return {
        ...state,
        loading: true,
        error: false
      };
    case Types.LOAD_HELPCENTER_SUCCESS:
      return {
        ...state,
        faq: {
          ...state.faq,
          categories: action.payload.faq.categories,
          question: action.payload.faq.question
        },
        loading: false,
        error: false,
        initialized: true
      };
    case Types.LOAD_HELPCENTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };

    case Types.LOAD_HELPCENTER_QUERY:
      return {
        ...state,
        faq: {
          ...state.faq,
          query: {
            ...state.faq.query,
            searchTerm: action.payload.faq.query.searchTerm
          }
        },
        loading: true,
        error: false
      };
    case Types.LOAD_HELPCENTER_QUERY_SUCCESS:
      return {
        ...state,
        faq: {
          ...state.faq,
          query: {
            ...state.faq.query,
            results: action.payload.faq.query.results
          }
        },
        loading: false,
        error: false
      };
    case Types.LOAD_HELPCENTER_QUERY_TOPICS_SUCCESS:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          searchResults: action.payload.results
        },
        loading: false,
        error: false
      };
    case Types.LOAD_HELPCENTER_QUERY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    case Types.LOAD_HELPCENTER_QUERY_CLEAN:
      return {
        ...state,
        faq: {
          ...state.faq,
          query: {
            searchTerm: '',
            results: []
          }
        },
        commerce: {
          ...state.commerce,
          searchResults: []
        },
        loading: false,
        error: false
      };

    case Types.LOAD_HELPCENTER_SUGGESTION:
      return {
        ...state,
        faq: {
          ...state.faq,
          suggestions: []
        },
        loading: true,
        error: false
      };
    case Types.LOAD_HELPCENTER_SUGGESTION_SUCCESS:
      return {
        ...state,
        faq: {
          ...state.faq,
          suggestions: action.payload.faq.suggestions
        },
        loading: false,
        error: false
      };
    case Types.LOAD_HELPCENTER_SUGGESTION_FAILURE:
      return {
        ...state,
        faq: {
          ...state.faq,
          suggestions: []
        },
        loading: false,
        error: true
      };

    case Types.LOAD_HELPCENTER_CATEGORIES:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          loadingCategories: true,
          error: false
        }
      };
    case Types.LOAD_HELPCENTER_CATEGORIES_SUCCESS:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          categories: action.payload.categories,
          loadingCategories: false,
          error: false
        }
      };
    case Types.LOAD_HELPCENTER_CATEGORIES_FAILURE:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          loadingCategories: false,
          error: true
        }
      };

    case Types.LOAD_HELPCENTER_TOPICS:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          loadingTopics: true,
          error: false
        }
      };
    case Types.LOAD_HELPCENTER_TOPICS_SUCCESS:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          topicsByCategory: {
            ...state.commerce.topicsByCategory,
            [action.payload.categoryId]: action.payload.topics
          },
          loadingTopics: false,
          error: false
        }
      };
    case Types.LOAD_HELPCENTER_TOPICS_FAILURE:
      return {
        ...state,
        commerce: {
          ...state.commerce,
          loadingTopics: false,
          error: true
        }
      };

    default:
      return state;
  }
};

export default reducer;
